// Properties Data Table Configuration - matching admin-web structure
import React, { useMemo } from 'react';
import { Text, View, StyleSheet } from 'react-native';
import { IColumnConfig } from '@/types/admin/dataTable';
import { IPropertyRowData } from '@/types/admin/properties';
import { useThemedStyles } from '@/hooks/shared/useThemeColors';

const useColumnStyles = () =>
  useThemedStyles(({ components }) =>
    StyleSheet.create({
      nameText: {
        fontWeight: '700',
        fontSize: 14,
        color: components.admin.dataCell.text,
      },
      cellText: {
        fontSize: 14,
        color: components.admin.dataCell.text,
      },
    }),
  );

const NameCell: React.FC<{ value: string }> = ({ value }) => {
  const styles = useColumnStyles();
  return (
    <View>
      <Text style={styles.nameText}>{value}</Text>
    </View>
  );
};

const TextCell: React.FC<{ value: string | number; fallback?: string }> = ({ value, fallback }) => {
  const styles = useColumnStyles();
  return (
    <View>
      <Text style={styles.cellText}>{value || fallback || ''}</Text>
    </View>
  );
};

export function usePropertyTableColumns(): IColumnConfig<IPropertyRowData>[] {
  return useMemo<IColumnConfig<IPropertyRowData>[]>(
    () => [
      {
        key: 'marketingName',
        label: 'NAME',
        width: 200,
        sortable: true,
        sortType: 'string',
        filterable: true,
        filterType: 'text',
        visible: true,
        renderCell: (value: string) => <NameCell value={value} />,
      },
      {
        key: 'externalId',
        label: 'EXTERNAL ID',
        width: 150,
        sortable: true,
        sortType: 'string',
        filterable: true,
        filterType: 'text',
        visible: true,
        renderCell: (value: number) => <TextCell value={value} />,
      },
      {
        key: 'address',
        label: 'ADDRESS',
        width: 250,
        sortable: true,
        sortType: 'string',
        filterable: true,
        filterType: 'text',
        visible: true,
        renderCell: (value: string) => <TextCell value={value} fallback="N/A" />,
      },
    ],
    [],
  );
}
